import React, { useEffect, useState } from "react";
// MUI Icons
import BadgeIcon from '@mui/icons-material/Badge';
import PersonIcon from '@mui/icons-material/Person';
import ClassIcon from '@mui/icons-material/Class';
import GroupsIcon from '@mui/icons-material/Groups';
import EmailIcon from '@mui/icons-material/Email';
import CakeIcon from '@mui/icons-material/Cake';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

function StudentProfileModal({ onClose }) {
    const [studentData, setStudentData] = useState(null);
    const [error, setError] = useState(null);

    const fetchStudentData = async () => {
        try {
            const token = sessionStorage.getItem("token");
            const apiUrl = process.env.REACT_APP_BASE_URL;

            const response = await fetch(`${apiUrl}/Attendance/StudentProfile`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: token,
                },
                body: JSON.stringify({
                    studentID: sessionStorage.getItem("employeeId"),
                }),
            });

            if (!response.ok) {
                throw new Error(`Error fetching student profile: ${response.status}`);
            }

            const data = await response.json();

            if (data.msg === "Record Not Found" || !data.objData) {
                throw new Error("Record Not Found");
            }

            setStudentData(data.objData);
        } catch (error) {
            setError(error.message);
            console.error(error);
        }
    };

    useEffect(() => {
        fetchStudentData();
    }, []);

    if (error) {
        return (
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                    backdropFilter: "blur(8px)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 9999,
                }}
            >
                <div
                    style={{
                        background: "white",
                        padding: "30px",
                        borderRadius: "16px",
                        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
                        textAlign: "center",
                    }}
                >
                    <div style={{ fontSize: "48px", marginBottom: "16px" }}>⚠️</div>
                    <div style={{ fontSize: "18px", color: "#d32f2f", fontWeight: "600" }}>
                        Error: {error}
                    </div>
                </div>
            </div>
        );
    }

    if (!studentData) {
        return (
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                    backdropFilter: "blur(8px)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 9999,
                }}
            >
                <div
                    style={{
                        background: "white",
                        padding: "40px",
                        borderRadius: "16px",
                        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
                        textAlign: "center",
                    }}
                >
                    <div
                        style={{
                            width: "48px",
                            height: "48px",
                            border: "4px solid #f3f3f3",
                            borderTop: "4px solid #4596a4",
                            borderRadius: "50%",
                            animation: "spin 1s linear infinite",
                            margin: "0 auto 20px",
                        }}
                    />
                    <div style={{ fontSize: "16px", color: "#666" }}>Loading...</div>
                    <style>
                        {`
                            @keyframes spin {
                                0% { transform: rotate(0deg); }
                                100% { transform: rotate(360deg); }
                            }
                        `}
                    </style>
                </div>
            </div>
        );
    }

    const InfoRow = ({ Icon, label, value }) => (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                padding: "6px 0",
                borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
            }}
        >
            <div
                style={{
                    fontSize: "18px",
                    marginRight: "10px",
                    minWidth: "20px",
                    textAlign: "center",
                    color: "#fff",
                }}
            >
                <Icon style={{ fontSize: "18px" }} />
            </div>
            <div style={{ flex: 1 }}>
                <div
                    style={{
                        fontSize: "10px",
                        color: "rgba(255, 255, 255, 0.7)",
                        marginBottom: "1px",
                        fontWeight: "500",
                        letterSpacing: "0.5px",
                    }}
                >
                    {label}
                </div>
                <div
                    style={{
                        fontSize: "13px",
                        color: "#ffffff",
                        fontWeight: "500",
                    }}
                >
                    {value || "-"}
                </div>
            </div>
        </div>
    );

    return (
        <div
            className="modal-overlay"
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.75)",
                backdropFilter: "blur(10px)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
                padding: "20px",
            }}
            onClick={onClose}
        >
            <div
                className="modal-content"
                style={{
                    background: "linear-gradient(135deg, #080F1F 0%, #102A43 55%, #1B4965 100%)",
                    padding: "12px",
                    borderRadius: "20px",
                    width: "100%",
                    maxWidth: "580px",
                    height: "auto",
                    boxShadow: "0 20px 60px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.1)",
                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                    position: "relative",
                    overflow: "hidden",
                    animation: "slideIn 0.3s ease-out",
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <style>
                    {`
                        @keyframes slideIn {
                            from {
                                opacity: 0;
                                transform: translateY(-20px) scale(0.95);
                            }
                            to {
                                opacity: 1;
                                transform: translateY(0) scale(1);
                            }
                        }
                    `}
                </style>

                {/* Decorative accent */}
                <div
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        height: "4px",
                        // background: "linear-gradient(90deg, #4596a4, #5dd8f3, #4596a4)",
                    }}
                />

                {/* Header */}
                <div
                    style={{
                        padding: "10px 18px",
                        borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <div
                            style={{
                                width: "36px",
                                height: "36px",
                                borderRadius: "10px",
                                background: "rgba(255, 255, 255, 0.15)",
                                backdropFilter: "blur(10px)",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                fontSize: "18px",
                            }}
                        >
                            <PersonIcon style={{ fontSize: "18px" }} />
                        </div>
                        <div>
                            <h2
                                style={{
                                    margin: 0,
                                    fontSize: "18px",
                                    fontWeight: "700",
                                    color: "#ffffff",
                                    letterSpacing: "-0.5px",
                                }}
                            >
                                Student Profile
                            </h2>
                            <p
                                style={{
                                    margin: "2px 0 0 0",
                                    fontSize: "11px",
                                    color: "rgba(255, 255, 255, 0.6)",
                                    fontWeight: "400",
                                }}
                            >
                                Academic Information
                            </p>
                        </div>
                    </div>
                </div>

                {/* Body - Two Column Layout */}
                <div style={{ padding: "16px 18px" }}>
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: "0 20px",
                        }}
                    >
                        <InfoRow Icon={BadgeIcon} label="ADMISSION NUMBER" value={studentData.admissionNo} />
                        <InfoRow Icon={PersonIcon} label="FULL NAME" value={studentData.studentName} />
                        <InfoRow Icon={ClassIcon} label="CLASS" value={studentData.className} />
                        <InfoRow Icon={GroupsIcon} label="SECTION" value={studentData.sectionName} />
                        <InfoRow Icon={EmailIcon} label="EMAIL ADDRESS" value={studentData.emailId} />
                        <InfoRow Icon={CakeIcon} label="DATE OF BIRTH" value={studentData.studentDOB} />
                        <InfoRow Icon={CalendarTodayIcon} label="ADMISSION DATE" value={studentData.admissionDate} />
                    </div>
                </div>

                {/* Footer */}
                <div
                    style={{
                        padding: "10px 18px",
                        borderTop: "1px solid rgba(255, 255, 255, 0.1)",
                        background: "rgba(0, 0, 0, 0.2)",
                        display: "flex",
                        justifyContent: "flex-end",
                    }}
                >
                    <button
                        onClick={onClose}
                        style={{
                            padding: "9px 22px",
                            background: "rgba(255, 255, 255, 0.15)",
                            backdropFilter: "blur(10px)",
                            border: "1px solid rgba(255, 255, 255, 0.3)",
                            borderRadius: "10px",
                            color: "#ffffff",
                            fontSize: "13px",
                            fontWeight: "600",
                            cursor: "pointer",
                            transition: "all 0.2s ease",
                            letterSpacing: "0.3px",
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.background = "rgba(255, 255, 255, 0.25)";
                            e.target.style.transform = "translateY(-2px)";
                            e.target.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.3)";
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.background = "rgba(255, 255, 255, 0.15)";
                            e.target.style.transform = "translateY(0)";
                            e.target.style.boxShadow = "none";
                        }}
                    >
                        Okay
                    </button>
                </div>
            </div>
        </div>
    );
}

export default StudentProfileModal;